window.theme = window.theme || {};

window.addEventListener("DOMContentLoaded", (event) => {
  /* ======= Free Shipping Bar (guarded: no throw if element missing; 429-safe) ========= */
  theme.FreeShippingBar = (function () {
    function update() {
      var bar = document.querySelector("#free-shipping-calculator");
      if (!bar || !bar.dataset || !bar.dataset.treshold) return;
      var promoteTxt = bar.dataset.promote || "";
      var unlockedTxt = bar.dataset.unlocked || "";
      var treshold = parseFloat(bar.dataset.treshold, 10) || 0;
      $.getJSON("/cart.js")
        .then(function (cart) {
          var value_left = treshold - cart.total_price;
          var value_left_money = typeof Shopify !== "undefined" && Shopify.formatMoney ? Shopify.formatMoney(value_left) : value_left;
          var percent = treshold ? (cart.total_price / treshold) * 100 : 0;
          if (!cart.total_price) {
            bar.innerHTML = "";
            if (bar.parentNode) bar.parentNode.classList.add("hidden");
            return;
          }
          bar.parentNode && bar.parentNode.classList.remove("hidden");
          if (value_left <= 0) {
            bar.innerHTML = '<label for="free-shipping-progress" class="free-shipping-calculator__label block text-center">' + unlockedTxt + "</label>" +
              '<div class="progress-container"><div id="free-ship-progress" style="width:' + percent + '%" class="free-shipping-calculator__progress text-center" data-value="' + percent + '" data-max="100"></div></div>';
          } else {
            bar.innerHTML = '<label for="free-shipping-progress" class="free-shipping-calculator__label block text-center">' + (promoteTxt.replace("[value]", value_left_money)) + "</label>" +
              '<div class="progress-container"><div id="free-ship-progress" style="width:' + percent + '%" class="free-shipping-calculator__progress text-center" data-value="' + percent + '" data-max="100"></div></div>';
          }
        })
        .catch(function () {});
    }
    return { update: update };
  })();

  $(theme).init();
});

/* Log Theme Version */
log = function () {
  var args = Array.prototype.slice.call(arguments);
  args.unshift(console);
  return Function.prototype.bind.apply(console.log, args);
};

jQuery(document).ready(function ($) {
  jQuery("body").delegate("input[name=id]", "change", function () {
    // jQuery('body input[name=id_var]').change(function () {

    var value = $(this).filter(":checked").val();
    var prod = $(this).attr("prod");

    //   alert(prod);
    jQuery(".new-var label").removeClass("active");
    jQuery(this).parent("label").addClass("active");
    jQuery("#product-select-" + prod + "-option-0")
      .val(value)
      .change();
  });

  $(".level-one>li").click(function () {
    $(this).parent(".level-one").find(".level-two").hide();
    $(this).parent(".level-one").children("li").removeClass("active");
    $(this).children(".level-two").show();
    $(this).addClass("active");
    $(".level-three").hide();
    //           }
  });

  $(".level-two li").click(function () {
    $(this).parent(".level-two").find(".level-three").hide();
    $(this).parent(".level-two").children("li").removeClass("active");
    //$(this).children('.level-three').show();
    $(this).addClass("active");
    var html1 = $(this).find("ul>li").html();
    // alert(html1);
    $(".level-three").hide();
    $(".size-show").text(html1);
  });
  $(".level-three li").click(function () {
    $(this).parent(".level-three").find(".level-four").hide();
    $(this).parent(".level-three").children("li").removeClass("active");
    $(this).children(".level-four").show();
    $(this).addClass("active");
  });
  $(".closeclick").click(function () {
    $(".popiphode").hide();
  });
  $(".sizeshow").click(function (e) {
    e.preventDefault();
    $(".popiphode").show("slow");
  });
});

/*============================================================================
    Fancy Box Popup
  ==============================================================================*/
$(document).ready(function () {
  // Call Fancybox globally on all elemnets with class "fancybox"
  $(".fancybox").fancybox({
    helpers: {
      overlay: {
        locked: false,
      },
    },
  });

  // Call Fancybox for product modal + stop scroll to top
  $(".product-modal").fancybox({
    afterShow: function () {
      var context = document.querySelector(".product-quick-view");
      // Events.trigger("quickview:load", context);
    },
    helpers: {
      overlay: {
        locked: false,
      },
    },
  });

  // Call Fancybox for search & mailing list signup + stop scroll to top
  $(".open_popup").fancybox({
    helpers: {
      overlay: {
        locked: false,
      },
    },
  });

  // Sidebar Toggle for screens below 980px wide
  var $Sidebar = $("#sidebar");
  $(document).on("click.toggleNav touch.toggleNav", ".show", function () {
    $Sidebar.toggleClass("open");
  });

  // Add class current on Main Nav
  jQuery(function () {
    jQuery("ul#main-nav li a").each(function () {
      if (jQuery(this).attr("href") === window.location.pathname) {
        jQuery(this).addClass("current");
      }
    });
  });

  // Blog sidebar position on mobile
  if ($(this).width() < 740) {
    $("ul#blog-articles").insertBefore("#blog-sidebar");
  }
});

/* ============
  Function Zoom
  ============= */
function zoomIn(event) {
  $(".product-img--main")
    // tile mouse actions
    .on("mouseover", function () {
      $(this)
        .children(".product-img--main__image")
        .css({ transform: "scale(" + $(this).attr("data-scale") + ")" });
    })
    .on("mouseout", function () {
      $(this)
        .children(".product-img--main__image")
        .css({ transform: "scale(1)" });
    })
    .on("mousemove", function (e) {
      $(this)
        .children(".product-img--main__image")
        .css({
          "transform-origin":
            ((e.pageX - $(this).offset().left) / $(this).width()) * 100 +
            "% " +
            ((e.pageY - $(this).offset().top) / $(this).height()) * 100 +
            "%",
        });
    })
    // tiles set up
    .each(function () {
      $(this)
        // add a image container
        .append('<div class="product-img--main__image"></div>')
        // set up a background image for each tile based on data-image attribute
        .children(".product-img--main__image")
        .css({ "background-image": "url(" + $(this).attr("data-image") + ")" });
    });
  // tyle.visibility = "hidden";
}
